'use strict';

import React from 'react';
import { useEffect, useState, useContext } from 'react';

import { Table, Button, Tabs, Tab, Modal, Row, Col } from 'react-bootstrap';

import useRequest from '../helper/useRequest';
import { formatDate, formatTime } from '../helper/DateTimeFormater';
import Alert from '../helper/Alert';
import { toast } from 'react-toastify';
import useConfirmation from '../helper/Confirmation';
import Loader from '../helper/Loader';
import Separator from '../helper/Separator';
import ModalCloseButton from '../helper/Modal/ModalCloseButton';

import Select from 'react-select';

import AppContext from '../AppContext';

import CustomFilter from '../helper/CustomFilter';

import {
    createColumnHelper,
    flexRender,
    getCoreRowModel,
    getSortedRowModel,
    getFilteredRowModel,
    useReactTable,
} from '@tanstack/react-table'
import TableHeader from '../helper/TableHeader';

const columnHelper = createColumnHelper();
const monthNames = ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"];

const EditTimeslotModal = ({ modal, setModal, timeslot, updateTimeslots }) => {
    const { request } = useRequest();
    const closeModal = () => {
        setModal(false);
    }
    const [message, setMessage] = useState("");
    const [contactPerson, setContactPerson] = useState(0);
    const [sndContactPerson, setSndContactPerson] = useState(0);
    const [persons, setPersons] = useState([]);
    const [contactPersons, setContactPersons] = useState([]);
    const [sndContactPersons, setSndContactPersons] = useState([]);

    var d = new Date(timeslot.Appointment + " " + timeslot.TimeStart);
    var dd = String(d.getDate()).padStart(2, '0');
    var mm = String(d.getMonth() + 1).padStart(2, '0');
    var yyyy = d.getFullYear();

    var today = dd + '.' + mm + '.' + yyyy + ", " + d.toLocaleDateString("de-DE", { weekday: 'short' });

    const editTimeslot = async (id) => {
        try {
            if (contactPerson.value != sndContactPerson.value) {
                setMessage("");
                const result = await request("/Business/EditTimeslot", { timeslotId: timeslot.TimeslotID, contactId: contactPerson.value, sndContactId: sndContactPerson.value });
                const json = result.data;

                if (json.r == 1) {
                    updateTimeslots(json.timeslot);
                    closeModal();
                    var today = new Date();
                    var hours = Math.floor(Math.abs(new Date(timeslot.Appointment + " " + timeslot.TimeStart) - today) / 36e5);
                    if (hours < 24) {
                        toast.info("Der gebuchte Termin findet in unter 24 Stunden statt.")
                    }
                    toast.success("Änderung wurde erfolgreich gespeichert.");
                }
                else {
                    setMessage(json.message);
                }
            }
            else {
                setMessage("Die beiden Ansprechpartner dürfen nicht die selbe Person sein.")
            }
        }
        catch (ex) {
            toast.error("Es ist ein Fehler aufgetreten.");
        }
    }

    const loadPersons = async () => {
        try {
            let result = await request("/User/GetContactpersons");
            let json = result.data;
            if (json.r != 1) {
                if (json.message) {
                    toast.error(json.message);
                }
                else {
                    toast.error("Es ist ein Fehler aufgetreten.");
                }
            }
            else {
                setPersons(json.persons);
            }
        }
        catch (ex) {
            toast.error("Es ist ein Fehler aufgetreten.");
        }
    };

    useEffect(() => {
        loadPersons();
    }, []);

    useEffect(() => {
        setMessage("");
        if (!timeslot) return;

        setContactPersons(persons.map(item =>
        {
            if (timeslot.CriminalRecord && item.CriminalRecord != 2) {
                return { value: item.ContactPersonID, label: item.FirstName + " " + item.LastName, isDisabled: true }
            }
            return { value: item.ContactPersonID, label: item.FirstName + " " + item.LastName }
        }));

        let sndPersonList = persons.map((item) => {
            if (timeslot.CriminalRecord && item.CriminalRecord != 2) {
                return { value: item.ContactPersonID, label: item.FirstName + " " + item.LastName, isDisabled: true }
            }

            return { value: item.ContactPersonID, label: item.FirstName + " " + item.LastName }
        });
        sndPersonList.splice(0, 0, { value: 0, label: "Kein Zweitreferent" });
        setSndContactPersons(sndPersonList);


        setContactPerson({ value: timeslot.ContactOrganisation.ContactPersonID, label: timeslot.ContactOrganisation.FirstName + " " + timeslot.ContactOrganisation.LastName })
        if (timeslot.SndContactOrganisation.ContactPersonId > 0) {
            setSndContactPerson({ value: timeslot.SndContactOrganisation.ContactPersonID, label: timeslot.SndContactOrganisation.FirstName + " " + timeslot.SndContactOrganisation.LastName })
        }
        else {
            setSndContactPerson(0);
        }
    }, [timeslot, persons]);

    if (!timeslot) return null;

    return (
        <Modal show={modal} onHide={closeModal}>
            <Modal.Header>
                <Modal.Title>Zeitsatz bearbeiten</Modal.Title>
                <ModalCloseButton onClick={closeModal} />
            </Modal.Header>
            <Modal.Body>
                
                <Row>
                    <Col sm={4}>
                        Schule
                    </Col>
                    <Col sm={8}>
                        {timeslot.OrganisationName}
                    </Col>
                </Row>
                <Row>
                    <Col sm={4}>
                        Typ
                    </Col>
                    <Col sm={8}>
                        {timeslot.TypeOfSchool}
                    </Col>
                </Row>
                <Row>
                    <Col sm={4}>
                        Stufe
                    </Col>
                    <Col sm={8}>
                        {timeslot.Grade}
                    </Col>
                </Row>
                <Row>
                    <Col sm={4}>
                        Klasse
                    </Col>
                    <Col sm={8}>
                        {timeslot.Class}
                    </Col>
                </Row>
                {timeslot.Room && (
                    <Row>
                        <Col sm={4}>
                            Raum
                        </Col>
                        <Col sm={8}>
                            {timeslot.Room}
                        </Col>
                    </Row>
                )}
                <Row>
                    <Col sm={4}>
                        Straße
                    </Col>
                    <Col sm={8}>
                        {timeslot.Street} {timeslot.HouseNo}
                    </Col>
                </Row>
                <Row>
                    <Col sm={4}>
                        Ort
                    </Col>
                    <Col sm={8}>
                        {timeslot.PostCode} {timeslot.City}
                    </Col>
                </Row>
                <Row>
                    <Col sm={4}>
                        Datum
                    </Col>
                    <Col sm={8}>
                        {today}
                    </Col>
                </Row>
                <Row>
                    <Col sm={4}>
                        Zeitraum
                    </Col>
                    <Col sm={8}>
                        {String(new Date(timeslot.Appointment + " " + timeslot.TimeStart).getHours()).padStart(2, "0")}:{String(new Date(timeslot.Appointment + " " + timeslot.TimeStart).getMinutes()).padStart(2, "0")}
                        -
                        {String(new Date(timeslot.Appointment + " " + timeslot.TimeEnd).getHours()).padStart(2, "0")}:{String(new Date(timeslot.Appointment + " " + timeslot.TimeEnd).getMinutes()).padStart(2, "0")} Uhr
                    </Col>
                </Row>
                <Row>
                    <Col sm={4}>
                        Ausstattung
                    </Col>
                    <Col sm={8}>
                        {timeslot.Equipment.map(item => item.Description).join(", ")}
                    </Col>
                </Row>
                
                <Separator style={{ marginBottom: "0.5rem" }} text="Referent für Schule" />
                <Row>

                    <Col sm={12}>
                        <div className="text-danger mb-2">
                           
                            Der Referent muss die Person sein, die diesen Termin durchführt. Andere Personen erhalten keinen Einlass in die Schule!
                        </div>
                        <Select name="contactPerson" options={contactPersons} value={contactPerson} classNamePrefix="bv-select" className="bv-select" onChange={
                            (values) => {
                                setContactPerson(values);
                            }
                        } />
                        {/*
                                {timeslot.CriminalRecord && (
                                <div>Der Referent benötigt ein verifiziertes erweitertes Führungszeugnis.</div>
                        )}*/}
                    </Col>
                </Row>
                <Separator style={{ marginBottom: "0.5rem" }} text="Zweitreferent für Schule" />
                <Row className="mb-3">

                    <Col sm={12}>
                        <p>Es kann ein Zweitreferent hinterlegt werden, der im Vertretungsfall diesen Termin alternativ durchführen kann. Andere Personen erhalten keinen Einlass in die Schule!</p>
                        <Select name="sndContactPerson" classNamePrefix="bv-select" className="bv-select" options={sndContactPersons} value={sndContactPerson} defaultValue={{ value: 0 }} onChange={
                            (values) => {
                                setSndContactPerson(values);
                            }
                        } />
                    </Col>
                </Row>

                {message && <Alert type="error" message={message} />}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="dark" onClick={closeModal}>
                    Abbrechen
                </Button>
                <Button variant="secondary" onClick={() => editTimeslot()}>
                    Speichern
                </Button>
            </Modal.Footer>
        </Modal>
    )
};

function OwnTimeslots() {
    const { request } = useRequest();
    const confirmation = useConfirmation();
    const { getSalutation } = useContext(AppContext);

    const [realTimeslots, setRealTimeslots] = useState(false);
    const [timeslots, setTimeslots] = useState(false);
    const [realTimeslotsPast, setRealTimeslotsPast] = useState(false);
    const [timeslotsPast, setTimeslotsPast] = useState(false);
    const [key, setKey] = useState('now');
    const [sorting, setSorting] = useState([]);
    const [columnFilters, setColumnFilters] = useState([]);
    const [year, setYear] = useState({ label: new Date().getFullYear(), value: new Date().getFullYear() });
    const [years, setYears] = useState([]);

    const [modal, setModal] = useState(false);
    const [timeslot, setTimeslot] = useState(false);

    const updateTimeslots = (id) => {
        setRealTimeslots((items) => {
            var newItems = items.filter((timeslot) => {
                if (timeslot.TimeslotID == id) {
                    return false;
                }
                return true;
            });
            return newItems;
        });
    };

    const editTimeslot = (timeslot) => {
        setRealTimeslots((items) => {
            return items.map(item => {
                if (item.TimeslotID == timeslot.TimeslotID) {
                    item.ContactPersonOrganisation = timeslot.ContactOrganisation.ContactPersonID;
                    item.ContactOrganisation = timeslot.ContactOrganisation;
                }

                return item;
            });
        });
    };

    const getContact = (slot) => {
        return (
            <>
                <div>{slot.OrganisationName}, {slot.Street} {slot.HouseNo}, {slot.PostCode} {slot.City}</div>
                {slot.ContactSchool && <div>{getSalutation(slot.ContactSchool.SalutationID)} {slot.ContactSchool.Title} {slot.ContactSchool.FirstName} {slot.ContactSchool.LastName} ({slot.ContactSchool.Email})</div>}
            </>
        );
    }

    const cancelTimeslot = async (id) => {
        try {
            let result = await request("/Business/CancelTimeslot", { timeslotid: id });
            let json = result.data;
            if (json.r != 1) {
                if (json.message) {
                    toast.error(json.message);
                }
                else {
                    toast.error("Es ist ein Fehler aufgetreten.");
                }
            }
            else {
                toast.success("Zeitsatz wurde storniert.");

                updateTimeslots(id);
            }
        }
        catch (ex) {
            console.error(ex);
            toast.error("Es ist ein Fehler aufgetreten.");
        }
    };

    const selectTimeslot = (slot) => {
        setModal(true);
        setTimeslot(realTimeslots.find(m => m.TimeslotID == slot.TimeslotID));
    }

    const columns = [
        columnHelper.accessor('Appointment', {
            header: () => <span>Datum</span>,
            cell: info => info.getValue(),  
            enableColumnFilter: true,
        }),
        columnHelper.accessor('TimeStart', {
            header: () => <span>Startzeit</span>,
            cell: info => formatTime(info.getValue()),
            enableColumnFilter: true,
        }),
        columnHelper.accessor('TimeEnd', {
            header: () => <span>Endzeit</span>,
            cell: info => formatTime(info.getValue()),
            enableColumnFilter: true,
        }),
        columnHelper.accessor('ContactSchoolID', {
            header: () => <span>Schule</span>,
            cell: info => getContact(info.row.original),
            enableSorting: false,
            enableColumnFilter: true,
        }),
        columnHelper.accessor('Grade', {
            header: () => <span>Stufe</span>,
            cell: info => info.getValue(),
            enableColumnFilter: true,
        }),
        columnHelper.accessor('Class', {
            header: () => <span>Klasse</span>,
            cell: info => info.getValue(),
            enableColumnFilter: true,
        }),
        columnHelper.accessor('Room', {
            header: () => <span>Raum</span>,
            cell: info => info.getValue(),
            enableColumnFilter: true,
        }),
        columnHelper.accessor('Equipment', {
            header: () => <span>Ausstattung</span>,
            cell: info => info.getValue(),
            enableSorting: false,
            enableColumnFilter: true,
        }),
        columnHelper.accessor('TimeslotID', {
            size: 200,
            header: () => <span></span>,
            cell: info => {
                return (
                    <div className="text-right">
                        <Button variant="primary" size="sm" className="mb-1" onClick={() => { selectTimeslot(info.row.original) } }>Bearbeiten</Button>
                        <Button variant="danger" size="sm" onClick={() => confirmation.openModal("Wirklich stornieren?", "Soll dieser Termin wirklich storniert werden?", () => { cancelTimeslot(info.getValue()) }, "Ja", "Nein")}>Stornieren</Button>
                    </div>
                );
            },
            enableSorting: false,
            enableColumnFilter: false,
        }),
    ]

    const reactTable = useReactTable({
        data: timeslots || [],
        columns,
        state: {
            sorting,
            columnFilters,
        },
        onSortingChange: setSorting,
        onColumnFiltersChange: setColumnFilters,

        getCoreRowModel: getCoreRowModel(),
        getSortedRowModel: getSortedRowModel(),
        getFilteredRowModel: getFilteredRowModel(),
    });

    const getTimeslots = async () => {
        try {
            let result = await request("/Business/GetBookedTimeslots");
            let json = result.data;
            if (json.r != 1) {
                if (json.message) {
                    toast.info(json.message);
                }
                else {
                    toast.error("Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.");
                }

                return setRealTimeslots([]);
            }

            setRealTimeslots(json.data);

            setYears(json.years.map(item => {
                return { label: item, value: item };
            }));

            if (json.data.length == 0) {
                toast.info("Es wurden keine Termine gefunden.");
            }
        }
        catch {
            toast.error("Laden der Termine fehlgeschlagen.");
        }
    };

    const getTimeslotsPast = async () => {
        try {
            setRealTimeslotsPast(false);
            let result = await request("/Business/GetBookedTimeslots", { past: true, year: year.value });
            let json = result.data;
            if (json.r != 1) {
                if (json.message) {
                    toast.info(json.message);
                }
                else {
                    toast.error("Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.");
                }

                return setRealTimeslotsPast([]);
            }

            setRealTimeslotsPast(json.data);
        }
        catch {
            toast.error("Laden der Termine fehlgeschlagen.");
        }
    };

    useEffect(() => {
        getTimeslots();
    }, []);

    useEffect(() => {
        getTimeslotsPast();
    }, [year]);

    useEffect(() => {
        if (!realTimeslots) return setTimeslots(realTimeslots);

        const slots = realTimeslots.map(m => {
            const newItem = { ...m };

            newItem.Appointment = formatDate(newItem.Appointment);

            newItem.ContactSchoolID = newItem.OrganisationName + " " + newItem.Street + " " + newItem.HouseNo + " " + newItem.PostCode + " " + newItem.City + " ";
            if (newItem.ContactSchool) {
                newItem.ContactSchoolID += getSalutation(newItem.ContactSchool.SalutationID) + " " + newItem.ContactSchool.Title + " " + newItem.ContactSchool.FirstName + " " + newItem.ContactSchool.LastName + " " + newItem.ContactSchool.Email;
            }

            newItem.Equipment = newItem.Equipment.map((item) => { return item.Description; }).join("; ")

            return newItem;
        });
        setTimeslots(slots);

    }, [realTimeslots]);

    useEffect(() => {
        if (!realTimeslotsPast) return setTimeslotsPast(realTimeslotsPast);

        const slots = realTimeslotsPast.map(m => {
            const newItem = { ...m };

            newItem.Appointment = formatDate(newItem.Appointment);

            newItem.ContactSchoolID = newItem.OrganisationName + " " + newItem.Street + " " + newItem.HouseNo + " " + newItem.PostCode + " " + newItem.City + " ";
            if (newItem.ContactSchool) {
                newItem.ContactSchoolID += getSalutation(newItem.ContactSchool.SalutationID) + " " + newItem.ContactSchool.Title + " " + newItem.ContactSchool.FirstName + " " + newItem.ContactSchool.LastName + " " + newItem.ContactSchool.Email;
            }

            newItem.Equipment = newItem.Equipment.map((item) => { return item.Description; }).join("; ")

            return newItem;
        });
        setTimeslotsPast(slots);

    }, [realTimeslotsPast]);

    if(timeslots === false) return <Loader />

    return (
        <>
            <Tabs
                id="contingent-tab"
                activeKey={key}
                onSelect={(k) => setKey(k)}
                className="mb-3"
            >
                <Tab key="now" eventKey="now" title="Aktuell">
                    <Table striped responsive="xl">
                        <thead>
                            {reactTable.getHeaderGroups().map(headerGroup => (
                                <TableHeader key={headerGroup.id} table={reactTable} headerGroup={headerGroup} flexRender={flexRender} />
                            ))}
                        </thead>
                        <tbody>
                            {reactTable.getRowModel().rows.map(row => (
                                <tr key={row.id}>
                                    {row.getVisibleCells().map(cell => {
                                        return (
                                            <td key={cell.id}>
                                                {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                            </td>
                                        )
                                    })}
                                </tr>
                            ))}
                        </tbody>

                    </Table>
                </Tab>
                <Tab key="past" eventKey="past" title="Vergangenheit">
                    <div className="mb-2 d-flex align-items-center" style={{ width: "320px" }}>
                        <label className="mr-2">Jahr</label>
                        <Select menuPortalTarget={document.body}
                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                            menuPosition={"fixed"} name="filterStatus" options={years} value={year} className="basic-multi-select" placeholder="Bitte auswählen" onChange={(values) => { setYear(values) }} />

                    </div>
                    <OwnTimeslotsPast timeslots={timeslotsPast}></OwnTimeslotsPast>
                </Tab>
            </Tabs>  
            <EditTimeslotModal modal={modal} setModal={setModal} timeslot={timeslot} updateTimeslots={editTimeslot} />
        </>
    ); 
}

const OwnTimeslotsPast = ({ timeslots, }) => {
    const { getSalutation } = useContext(AppContext);
    const [sorting, setSorting] = useState([]);
    const [columnFilters, setColumnFilters] = useState([]);

    const getContact = (slot) => {
        // if (!booked) return "";
        return (
            <>
                {(slot.AdditionToAddress == "" || slot.AdditionToAddress == null)
                    ? <div>{slot.OrganisationName}, {slot.Street} {slot.HouseNo}, {slot.PostCode} {slot.City}</div>
                    : <div>{slot.OrganisationName}, {slot.Street} {slot.HouseNo}, {slot.AdditionToAddress}, {slot.PostCode} {slot.City}</div>}
                {slot.ContactSchool && <div>{getSalutation(slot.ContactSchool.SalutationID)} {slot.ContactSchool.Title} {slot.ContactSchool.FirstName} {slot.ContactSchool.LastName} ({slot.ContactSchool.Email})</div>}
            </>
        );
    }

    const columns = [
        columnHelper.accessor('Appointment', {
            header: () => <span>Datum</span>,
            cell: info => info.getValue(),
            enableColumnFilter: true,
        }),
        columnHelper.accessor('TimeStart', {
            header: () => <span>Startzeit</span>,
            cell: info => formatTime(info.getValue()),
            enableColumnFilter: true,
        }),
        columnHelper.accessor('TimeEnd', {
            header: () => <span>Endzeit</span>,
            cell: info => formatTime(info.getValue()),
            enableColumnFilter: true,
        }),
        columnHelper.accessor('ContactSchoolID', {
            header: () => <span>Schule</span>,
            cell: info => getContact(info.row.original),
            enableColumnFilter: true,
            enableSorting: false,
        }),
        columnHelper.accessor('Grade', {
            header: () => <span>Stufe</span>,
            cell: info => info.getValue(),
            enableColumnFilter: true,
        }),
        columnHelper.accessor('Class', {
            header: () => <span>Klasse</span>,
            cell: info => info.getValue(),
            enableColumnFilter: true,
        }),
        columnHelper.accessor('Room', {
            header: () => <span>Raum</span>,
            cell: info => info.getValue(),
            enableColumnFilter: true,
        }),
        columnHelper.accessor('Equipment', {
            header: () => <span>Ausstattung</span>,
            cell: info => info.getValue(),
            enableSorting: false,
            enableColumnFilter: true,
        })
    ]
    
    const t = useReactTable({
        data: timeslots || [],
        columns,
        state: {
            sorting,
            columnFilters,
        },
        onSortingChange: setSorting,
        onColumnFiltersChange: setColumnFilters,

        getCoreRowModel: getCoreRowModel(),
        getSortedRowModel: getSortedRowModel(),
        getFilteredRowModel: getFilteredRowModel(),
    });

    if (timeslots === false) return <Loader />

    return (
        <Table striped responsive="xl">
            <thead>
                {t.getHeaderGroups().map(headerGroup => (
                    <tr key={headerGroup.id}>
                        {headerGroup.headers.map(header => {
                            return (
                                <th key={header.id} style={{ whiteSpace: "nowrap" }}>
                                    {header.isPlaceholder
                                        ? null
                                        : (
                                            <>
                                                <div {...{
                                                    className: header.column.getCanSort()
                                                        ? 'cursor-pointer select-none'
                                                        : '',
                                                    onClick: header.column.getToggleSortingHandler(),
                                                }}>
                                                    {flexRender(
                                                        header.column.columnDef.header,
                                                        header.getContext()
                                                    )}
                                                    {{
                                                        asc: <i className="fa-solid fa-sort-up ms-2"></i>,
                                                        desc: <i className="fa-solid fa-sort-down ms-2"></i>,
                                                    }[header.column.getIsSorted()] ?? (header.column.getCanSort() ? <i className="fa-solid fa-sort ms-2"></i> : null)}
                                                </div>
                                                {header.column.getCanFilter() ? (
                                                    <div>
                                                        <CustomFilter column={header.column} table={t} />
                                                    </div>
                                                ) : null}
                                            </>
                                        )
                                    }
                                </th>
                            )
                        })}
                    </tr>
                ))}
            </thead>
            <tbody>
                {t.getRowModel().rows.map(row => (
                    <tr key={row.id}>
                        {row.getVisibleCells().map(cell => {
                            return (
                                <td key={cell.id}>
                                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                </td>
                            )
                        })}
                    </tr>
                ))}
            </tbody>
        </Table>
    );
}

export default OwnTimeslots;